/*--------------------
|
| TinyMCE default config
|
--------------------*/

var getConfig = function(options) {

    var assetsPath = $('meta[name="assets-path"]').attr('content');

    var baseTinymceConfig = {
        license_key: 'gpl',
        menubar: false,
        selector: 'textarea.richTextBox',
        skin_url: assetsPath+'?path=js/skins/ui/oxide',
        content_css: assetsPath+'?path=js/skins/content/default/content.min.css',
        skin: 'oxide',
        min_height: 600,
        resize: true,
        plugins: 'link image code table lists',
        relative_urls: false,
        remove_script_host: false,
        file_picker_types: 'image',
        file_picker_callback: function(callback, value, meta) {
            if (meta.filetype === 'image') {
                var uploadInput = document.getElementById('upload_file');

                if (uploadInput) {
                    uploadInput.click();
                }
            }
        },
        toolbar: 'undo redo | blocks | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | bullist numlist outdent indent | link image table | code',
        image_caption: true,
        image_title: true,
        init_instance_callback: function (editor) {
            if (typeof tinymce_init_callback !== "undefined") {
                tinymce_init_callback(editor);
            }
        },
        setup: function (editor) {
            if (typeof tinymce_setup_callback !== "undefined") {
                tinymce_setup_callback(editor);
            }
        }
    };

    return $.extend({}, baseTinymceConfig, options);
}

exports.getConfig = getConfig;
